// extracted by mini-css-extract-plugin
module.exports = {"trending-container":"_3uFf0","headline":"_3qCtD"};